import { useGetDatasource } from "hooks/useMasterData";
import styled from "@emotion/styled";
import {  Form, FormInstance, Input, Select, Switch } from "antd";
import { FC } from "react";
const { Option } = Select;

interface DescriptionFormProps {
  form: FormInstance;
}

const DescriptionForm: FC<DescriptionFormProps> = ( form ) => {


  return (
  <FormWrapper>

    <FormItems
      labelAlign="left"
      label="ชื่อจุดจอด"
      name="name"
      rules={[{ required: true, message: "กรุณากรอกชื่อจุดจอด" }]}
    >
      <Input
        placeholder="ชื่อจุดจอด"
        size="small"
        autoComplete="off"
      />     
    </FormItems>

  </FormWrapper>
  );
};

export default DescriptionForm;

const FormItems = styled(Form.Item)`
  margin-bottom: 10px;
  width:100%
`
const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 20px 2px 20px;
  background-color: #ffffffff;
`;
// border-radius: 8px;


const TextWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 10px 10px 0px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;